module.exports = __webpack_public_path__ + "img/DK37536814.0c94f5be.png";